<mat-form-field appearance="outline" class="w-full">
  <mat-label>{{ title }}</mat-label>
  <input
    matInput
    [matDatepicker]="picker"
    [ngModel]="value"
    (focusout)="change(value)"
    (dateChange)="change($event.value)"
    autocomplete="off"
    [disabled]="disabled"
  />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker [touchUi]="bMobile" #picker></mat-datepicker>
</mat-form-field>
